/* eslint-disable arrow-body-style */
import { Container, Paper, Text } from '@mantine/core'
import useTranslation from 'next-translate/useTranslation'

const PrivacyPolicyTab = () => {
  const { lang } = useTranslation('client')
  return (
    <Container size="sm">
      <Paper>
        {lang === 'en' ? (
          <div style={{ marginBottom: 30 }}>
            <Text
              size="xl"
              weight={700}
              style={{ marginBottom: 20, marginTop: 30 }}
            >
              Privacy Policy
            </Text>
            <Text size="lg">
              Introduction Welcome to Infinity Medical Academy privacy policy,
              we are committed to protecting the privacy and confidentiality of
              personal data in accordance with applicable data protection laws
              and regulations, including those of Saudi Arabia. This privacy
              policy outlines how we collect, use, disclose, and protect your
              personal information when you visit our website or use our
              services. We understand the importance of transparency in our data
              processing practices, and we strive to provide you with clear and
              concise information about how your personal data is handled. By
              using our website or services, you consent to the collection, use,
              and disclosure of your personal information as described in this
              policy. Please take the time to read this privacy policy carefully
              to understand our practices regarding your personal data and how
              we safeguard your privacy. If you have any questions or concerns
              about our privacy practices, please feel free to contact us using
              the information provided at the end of this policy. Thank you for
              choosing Infinity Medical Academy. We value your trust and are
              committed to protecting your privacy every step of the way.
            </Text>
            <Text
              size="xl"
              weight={700}
              style={{ marginBottom: 20, marginTop: 30 }}
            >
              Types of Information Collected:
            </Text>
            <Text size="lg">
              At Infinity Medical Academy we may collect, use, store, and
              transfer various types of personal data to provide you with our
              services effectively. Personal data refers to any information that
              relates to an identified or identifiable individual, whether
              directly or indirectly. The types of personal data we may collect
              include but are not limited to: Contact Information: This includes
              your email address, which we may use to communicate with you
              regarding our services, updates, and important notifications.
              Location Data: We may collect geographic information regarding the
              location of your specific device associated with a time
              identifier. This information helps us personalize your experience
              and provide relevant services based on your location. Marketing
              and Information Preferences: We may gather data about your
              preferences related to receiving information about our website,
              services, promotions, and other marketing communications. This
              allows us to tailor our communications to better suit your
              interests. Digital Data: We may collect metadata, which is a set
              of data that describes other data and provides information about
              it. Additionally, we may collect internet identifiers such as
              Internet Protocol (IP) addresses, cookie identifiers, and other
              information when you visit our website. This data helps us analyze
              user behavior, improve our services, and enhance website
              functionality.
            </Text>
            <Text
              size="xl"
              weight={700}
              style={{ marginBottom: 20, marginTop: 30 }}
            >
              How Information is Collected:
            </Text>
            <Text size="lg">
              At Infinity Medical Academy, we collect personal data through
              various means to ensure the efficient delivery of our services and
              a personalized user experience. The following are the primary
              methods through which we gather personal information: Website
              Registration: Personal data is collected when you register on our
              website, https://www.infinity.edu.sa, by providing relevant
              information such as your name, email address, and other necessary
              details. "Become a Trainer" Form: If you choose to become a
              trainer with us, we may collect personal data through the "Become
              a Trainer" form, where you provide information about your
              qualifications, experience, and other relevant details. "Request a
              Course" Form: When you request a course through our website, we
              may collect personal data via the "Request a Course" form, which
              may include your contact details and specific requirements for the
              requested course. Through these methods, we gather the necessary
              information to effectively provide our services, communicate with
              you regarding your inquiries and requests, and tailor our
              offerings to your preferences and needs. We are committed to
              transparent data collection practices and will only collect
              personal information that is relevant and necessary for the
              purposes outlined in our privacy policy.
            </Text>

            {/* Purposes of Data Processing */}
            <Text
              size="xl"
              weight={700}
              style={{ marginBottom: 20, marginTop: 30 }}
            >
              Purposes of Data Processing:
            </Text>
            <Text>
              At Infinity Medical Academy, we process personal data for specific
              purposes to ensure the effective delivery of our services and to
              meet the needs of our clients. The following are the primary
              purposes for which we collect and process personal data: Providing
              Training Services: We collect personal data, including contact
              details and relevant information about your professional
              background, to provide you with training services tailored to your
              needs and preferences. This may include organizing training
              sessions, workshops, and seminars in your field of expertise.
              Communication and Updates: We use your personal data to
              communicate with you regarding important updates, developments,
              and activities related to your training and professional
              development. This may include sending you notifications about new
              courses, training materials, and accreditation opportunities.
              Obtaining Accredited Certificates: We collect personal data to
              facilitate the process of obtaining accredited certificates and
              educational hours that will enhance your professional and academic
              credentials. This may involve processing financial and banking
              details for payment operations and confirming reservations for
              training sessions and examinations. Improving Services: We may
              analyze personal data to gain insights into user preferences,
              behavior patterns, and training needs. This information helps us
              improve our services, develop new training programs, and enhance
              the overall user experience for our clients. Compliance with Legal
              Obligations: We process personal data in accordance with
              applicable laws and regulations, including those related to data
              protection and privacy. This may involve fulfilling legal
              obligations, responding to legal requests, and ensuring compliance
              with regulatory requirements.
            </Text>
            {/* Data Sharing */}
            <Text
              size="xl"
              weight={700}
              style={{ marginBottom: 20, marginTop: 30 }}
            >
              Data Sharing:
            </Text>
            <Text>
              At Infinity Medical Academy, we understand the importance of
              safeguarding your personal data and limiting access to it only
              when necessary. We may need to share your personal information
              with certain third parties to facilitate the provision of our
              services and ensure the smooth operation of our business. The
              following outlines the circumstances under which we may share your
              personal data: Internal Sharing: We limit access to your personal
              data to authorized personnel within our organization who have a
              legitimate need to access this information for the purpose of
              carrying out their job responsibilities. Our employees are bound
              by strict confidentiality obligations and are trained to handle
              personal data securely and responsibly. External Sharing: In
              certain situations, we may need to share your personal data with
              external parties, including: External Auditors: We may share
              personal data with external auditors for the purpose of conducting
              audits and assessments to ensure compliance with legal and
              regulatory requirements, as well as to maintain the integrity of
              our operations. Legal Services Companies: We may disclose personal
              data to legal services companies to obtain legal advice, respond
              to legal inquiries, and fulfill legal obligations. IT Services
              Companies: We may engage IT services companies to provide
              technical support, maintenance, and security services for our
              systems and infrastructure, which may involve access to personal
              data. Business Partners and Service Providers: We may share
              personal data with trusted business partners and service providers
              who assist us in delivering our services, such as training
              providers, accreditation bodies, and logistics partners. Banks: We
              may share financial and banking details with banks and financial
              institutions to process payment transactions, confirm
              reservations, and facilitate transfers related to our services.
            </Text>
            {/* Data Protection Measures */}
            <Text
              size="xl"
              weight={700}
              style={{ marginBottom: 20, marginTop: 30 }}
            >
              Data Protection Measures:
            </Text>
            <Text>
              At Infinity Medical Academy, we prioritize the security and
              protection of your personal data to safeguard it against
              unauthorized access, disclosure, alteration, or destruction. We
              have implemented robust data protection measures to ensure the
              confidentiality, integrity, and availability of your personal
              information. The following are some of the key measures we have in
              place: Secure Storage and Processing: We process and store
              personal information on secure servers and computer systems that
              are protected by industry-standard security protocols and
              measures. Our infrastructure is regularly monitored and audited to
              identify and address any potential vulnerabilities or threats.
              Encryption: We use encryption technologies to encrypt sensitive
              data during transmission and storage, including financial and
              banking details, to prevent unauthorized access and ensure data
              confidentiality. Access Control: Access to personal data is
              restricted to authorized personnel who have a legitimate need to
              access this information for the purpose of performing their job
              responsibilities. Access permissions are granted based on the
              principle of least privilege to minimize the risk of unauthorized
              access. Data Minimization: We collect and process only the
              personal data that is necessary for the purposes outlined in our
              privacy policy. We do not retain personal data for longer than
              necessary and ensure that any data that is no longer needed is
              securely disposed of or anonymized to prevent unauthorized access.
              Employee Training: Our employees undergo regular training and
              awareness programs on data protection and privacy best practices
              to ensure they understand their responsibilities and obligations
              regarding the handling of personal data. They are required to
              adhere to strict confidentiality agreements and ethical standards.
              Regular Audits and Assessments: We conduct regular audits and
              assessments of our data processing practices, security measures,
              and systems to identify and address any potential vulnerabilities,
              risks, or compliance gaps. We continuously strive to improve our
              data protection measures to enhance the security of your personal
              information. Compliance with Legal Requirements: We ensure that
              our data processing practices comply with all applicable data
              protection laws and regulations, including those of Saudi Arabia.
              We monitor changes in legislation and regulatory requirements to
              ensure ongoing compliance and make necessary updates to our
              policies and procedures. By implementing these data protection
              measures, we aim to provide you with peace of mind knowing that
              your personal data is handled securely and in accordance with the
              highest standards of data protection and privacy.
            </Text>
            {/* User Rights */}
            <Text
              size="xl"
              weight={700}
              style={{ marginBottom: 20, marginTop: 30 }}
            >
              User Rights:
            </Text>
            <Text>
              At Infinity Medical Academy, we are committed to respecting and
              upholding your rights regarding your personal data. As a data
              subject, you have certain rights under applicable data protection
              laws, including but not limited to: Right to Information: You have
              the right to be informed about the legal or practical
              justification for the collection of your personal data and the
              purposes for which it will be processed. We are transparent about
              our data processing practices and provide clear information about
              how your personal data is collected, used, and protected. Right to
              Access: You have the right to access the personal data that we
              hold about you. Upon request, we will provide you with a copy of
              your personal data in a commonly used electronic format. We may
              require verification of your identity before processing your
              request to ensure the security of your personal information. Right
              to Rectification: If you believe that any of the personal data we
              hold about you is inaccurate, incomplete, or outdated, you have
              the right to request that we correct, update, or amend it. We will
              promptly review your request and make any necessary corrections to
              ensure the accuracy of your personal information. Right to
              Erasure: You have the right to request the deletion or removal of
              your personal data in certain circumstances, such as when the data
              is no longer necessary for the purposes for which it was collected
              or processed, or when you withdraw your consent for processing.
              However, please note that we may be required to retain certain
              personal data for legal or regulatory compliance purposes. Right
              to Object: You have the right to object to the processing of your
              personal data under certain circumstances, such as when the
              processing is based on legitimate interests or for direct
              marketing purposes. We will respect your wishes and cease
              processing your personal data unless there are compelling
              legitimate grounds for the processing that override your
              interests, rights, and freedoms. We are committed to facilitating
              the exercise of your rights in relation to your personal data and
              will respond to any requests promptly and in accordance with
              applicable data protection laws. If you wish to exercise any of
              your rights or have any questions or concerns about our data
              processing practices, please contact us using the information
              provided at the end of this policy.
            </Text>
            {/* Contact Information */}
            <Text
              size="xl"
              weight={700}
              style={{ marginBottom: 20, marginTop: 30 }}
            >
              Contact Information:
            </Text>
            <Text>
              If you have any questions, concerns, or inquiries regarding our
              privacy policy, data processing practices, or your personal data,
              please do not hesitate to contact us. You can reach us using the
              following contact details: Infinity Medical Academy Baghdadiyah
              district - Hail Road and Crown Prince Road, Jeddah, Kingdom of
              Saudi Arabia Phone Numbers: Main Office: +966570322051 Alternate
              Office: +966564572240 Email Address: info@infinity.edu.sa Our
              dedicated team is available to assist you and address any concerns
              you may have regarding your personal data or our privacy
              practices. We strive to provide timely and comprehensive responses
              to all inquiries and ensure that your privacy rights are respected
              and upheld.
            </Text>
            {/* Legal Compliance */}
            <Text
              size="xl"
              weight={700}
              style={{ marginBottom: 20, marginTop: 30 }}
            >
              Legal Compliance:
            </Text>
            <Text>
              Infinity Medical Academy is committed to complying with all
              applicable data protection laws and regulations, including those
              of Saudi Arabia. Our data processing practices adhere to the
              requirements set forth by the relevant authorities to ensure the
              protection and confidentiality of your personal information. As a
              data controller, Infinity Medical Academy ensures that all
              processing activities involving personal data are conducted in
              accordance with the principles and provisions outlined in the
              applicable data protection legislation of Saudi Arabia. We are
              dedicated to upholding the rights of individuals regarding their
              personal data and strive to maintain the highest standards of data
              protection. Should you have any questions or concerns about our
              compliance with data protection laws, please do not hesitate to
              contact us.
            </Text>

            {/* Continue adding the rest of the policy */}
          </div>
        ) : (
          <div style={{ marginBottom: 30 }} dir="rtl">
            <Text
              size="xl"
              weight={700}
              style={{ marginBottom: 20, marginTop: 30 }}
            >
              الخصوصية سياسة
            </Text>
            <Text size="lg">
              المقدمة نحن الطبية، إنفينيتي لأكاديمية الخصوصية سياسة في بكم
              مرحبًا لقوانين وفقًا الشخصية البيانات وسرية خصوصية بحماية ملتزمون
              في بها المعمول تلك ذلك في بما بها، المعمول البيانات حماية وأنظمة
              جمع كيفية هذه الخصوصية سياسة توضح .السعودية العربية المملكة زيارتك
              عند وحمايتها عنها والكشف واستخدامها الشخصية معلوماتك في الشفافية
              أهمية نتفهم نحن .خدماتنا استخدام أو الإلكتروني لموقعنا بمعلومات
              لتزويدك جاهدين ونسعى لدينا، البيانات معالجة ممارسات باستخدامها
              الشخصية كيفية حول وموجزة واضحة واستخدامها الشخصية معلوماتك جمع على
              توافق فإنك خدماتنا، أو موقعنا الكافي الوقت أخذ يرجى .السياسة هذه
              في موضح هو كما عنها والكشف يتعلق فيما ممارساتنا لفهم بعناية هذه
              الخصوصية سياسة لقراءة أو أسئلة أية لديك كانت إذا .خصوصيتك نحمي
              وكيف الشخصية ببياناتك باستخدام بنا الاتصال في تتردد فلا لدينا،
              الخصوصية ممارسات بشأن مخاوف أكاديمية لاختيارك شكرًا .السياسة هذه
              نهاية في المقدمة المعلومات على خطوة كل في خصوصيتك بحماية ونلتزم
              ثقتك نقدر نحن .الطبية إنفينيتي
            </Text>
            <Text
              size="xl"
              weight={700}
              style={{ marginBottom: 20, marginTop: 30 }}
            >
              أنواع المعلومات المجمعة:
            </Text>
            <Text size="lg">
              في أكاديمية الطبية Infinity، نقوم بجمع البيانات الشخصية من خلال
              وسائل مختلفة لضمان تقديم خدماتنا بكفاءة وتجربة مستخدم مخصصة.
              الأنواع الشائعة من البيانات الشخصية التي قد نجمعها تشمل ولكن لا
              تقتصر على ذلك: معلومات الاتصال: يشمل ذلك عنوان بريدك الإلكتروني،
              الذي قد نستخدمه للتواصل مع يتعلق بك بخصوص خدماتنا، والتحديثات،
              والإشعارات الهامة. بيانات الموقع: قد نجمع معلومات جغرافية بشأن
              موقع جهازك المحدد بمعرف زمني. تساعدنا هذه المعلومات على تخصيص
              تجربتك وتوفير خدمات ذات صلة استنادًا إلى موقعك. تفضيلات التسويق
              والمعلومات: قد نجمع بيانات حول تفضيلاتك المتعلقة بتلقي المعلومات
              حول موقعنا على الويب، والخدمات، والعروض الترويجية، وغيرها من
              التواصلات التسويقية. البيانات الرقمية: قد نجمع البيانات الوصفية،
              وهي مجموعة من البيانات التي تصف بيانات أخرى وتوفر معلومات حولها.
              بالإضافة إلى ذلك، قد نجمع معرّفات الإنترنت مثل عناوين بروتوكول
              الإنترنت (IP)، ومعرفات الكوكي، وغيرها من المعلومات عند زيارتك
              لموقعنا على الويب. هذه البيانات تساعدنا في تحليل سلوك المستخدمين،
              وتحسين خدماتنا، وتعزيز وظائف الموقع على الويب.
            </Text>
            <Text
              size="xl"
              weight={700}
              style={{ marginBottom: 20, marginTop: 30 }}
            >
              كيفية جمع المعلومات:
            </Text>
            <Text size="lg">
              في أكاديمية الطبية Infinity، نقوم بجمع البيانات الشخصية من خلال
              وسائل مختلفة لضمان تقديم خدماتنا بكفاءة وتجربة مستخدم مخصصة.
              الأساليب الرئيسية التي نجمع بها المعلومات الشخصية هي: التسجيل على
              الموقع: يتم جمع البيانات الشخصية عند التسجيل على موقعنا على الويب،
              https://www.infinity.edu.sa، من خلال تقديم المعلومات اللازمة مثل
              الاسم وعنوان البريد الإلكتروني، وغيرها من التفاصيل الضرورية. نموذج
              "كن مدربًا": إذا اخترت أن تصبح مدربًا معنا، فقد نجمع البيانات
              الشخصية من خلال نموذج "كن مدربًا"، حيث تقدم معلومات حول مؤهلاتك
              وخبرتك، وغيرها من التفاصيل ذات الصلة. نموذج "طلب دورة": عند طلب
              دورة من خلال موقعنا على الويب، قد نجمع البيانات الشخصية عبر نموذج
              "طلب دورة"، والذي قد يتضمن تفاصيل الاتصال الخاصة بك والمتطلبات
              المحددة للدورة المطلوبة. من خلال هذه الطرق، نقوم بجمع المعلومات
              اللازمة لتقديم خدماتنا بفعالية، والتواصل معك بشأن استفساراتك
              وطلباتك، وتصميم عروضنا وفقًا لتفضيلاتك واحتياجاتك. نحن ملتزمون
              بممارسات شفافة لجمع البيانات وسنقوم فقط بجمع المعلومات الشخصية
              التي تكون ذات صلة وضرورية للأغراض الموضحة في سياسة الخصوصية لدينا.
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginBottom: 20, marginTop: 30 }}
            >
              أهداف معالجة البيانات:
            </Text>
            <Text>
              في أكاديمية الطبية Infinity، نقوم بمعالجة البيانات الشخصية لأغراض
              محددة لضمان تقديم خدماتنا بفعالية وتلبية احتياجات عملائنا. وفيما
              يلي الأغراض الرئيسية لجمع ومعالجة البيانات الشخصية: تقديم خدمات
              التدريب: نجمع البيانات الشخصية، بما في ذلك تفاصيل الاتصال
              والمعلومات ذات الصلة بخلفيتك المهنية، لتزويدك بخدمات التدريب مصممة
              خصيصًا لاحتياجاتك وتفضيلاتك. ويمكن أن تتضمن ذلك تنظيم جلسات
              تدريبية، وورش عمل، وندوات في مجال خبرتك. التواصل والتحديثات:
              نستخدم بياناتك الشخصية للتواصل معك بشأن التحديثات الهامة،
              والتطورات، والأنشطة المتعلقة بتدريبك وتطويرك المهني. ويمكن أن يشمل
              ذلك إرسال إشعارات حول دورات جديدة، ومواد تدريبية، وفرص الاعتماد.
              الحصول على شهادات معتمدة: نجمع البيانات الشخصية لتيسير عملية
              الحصول على الشهادات المعتمدة وساعات التعليم التي ستعزز مؤهلاتك
              المهنية والأكاديمية. وقد ينطوي ذلك على معالجة التفاصيل المالية
              والمصرفية لعمليات الدفع وتأكيد الحجوزات لجلسات التدريب
              والامتحانات. تحسين الخدمات: قد نقوم بتحليل البيانات الشخصية للحصول
              على رؤى حول تفضيلات المستخدمين، وأنماط السلوك، واحتياجات التدريب.
              تساعدنا هذه المعلومات على تحسين خدماتنا، وتطوير برامج تدريبية
              جديدة، وتعزيز تجربة المستخدم العامة لعملائنا. الامتثال للالتزامات
              القانونية: نقوم بمعالجة البيانات الشخصية وفقًا للقوانين والتشريعات
              السارية، بما في ذلك تلك المتعلقة بحماية البيانات والخصوصية. وقد
              يشمل ذلك الامتثال بالتزامات قانونية، والاستجابة للطلبات القانونية،
              وضمان الامتثال للمتطلبات التنظيمية. من خلال معالجة البيانات
              الشخصية لهذه الأغراض، نهدف إلى تقديم خدمات تدريبية عالية الجودة،
              ودعم أهداف التطوير المهني الخاصة بك، وضمان الامتثال للمعايير
              القانونية والتنظيمية.
            </Text>
            <Text
              size="xl"
              weight={700}
              style={{ marginBottom: 20, marginTop: 30 }}
            >
              مشاركة البيانات:
            </Text>
            <Text>
              في أكاديمية الطبية Infinity، ندرك أهمية حماية بياناتك الشخصية
              وتقييدها بالوصول إليها فقط عند الضرورة. قد نحتاج إلى مشاركة
              معلوماتك الشخصية مع أطراف ثالثة معينة لتسهيل تقديم خدماتنا وضمان
              سلسة عمل أعمالنا. وفيما يلي ملامح الظروف التي قد نشارك فيها
              بياناتك الشخصية: المشاركة الداخلية: نحدد الوصول إلى بياناتك
              الشخصية للموظفين المصرح لهم داخل منظمتنا الذين لديهم حاجة شرعية
              للوصول إلى هذه المعلومات لأداء مسؤولياتهم الوظيفية. يلتزم موظفونا
              بالالتزام بالتزامات السرية الصارمة وتلقوا تدريبًا على التعامل
              بأمان مع البيانات الشخصية. المشاركة الخارجية: في بعض الحالات، قد
              نحتاج إلى مشاركة بياناتك الشخصية مع أطراف خارجية، بما في ذلك:
              المدققون الخارجيون: قد نشارك البيانات الشخصية مع المدققين
              الخارجيين لغرض إجراء الفحوصات والتقييمات لضمان الامتثال للمتطلبات
              القانونية والتنظيمية، وكذلك للحفاظ على سلامة عملياتنا. شركات
              الخدمات القانونية: قد نكشف عن البيانات الشخصية لشركات الخدمات
              القانونية للحصول على النصائح القانونية، والرد على الاستفسارات
              القانونية، وتحقيق الالتزامات القانونية. شركات خدمات تكنولوجيا
              المعلومات: قد نشارك شركات خدمات تكنولوجيا المعلومات لتقديم الدعم
              الفني، والصيانة، وخدمات الأمان لأنظمتنا وبنيتنا التحتية، مما قد
              ينطوي على الوصول إلى البيانات الشخصية. شركاء الأعمال ومقدمي
              الخدمات: قد نشارك البيانات الشخصية مع شركاء الأعمال ومقدمي الخدمات
              الموثوق بهم الذين يساعدوننا في تقديم خدماتنا، مثل مقدمي التدريب،
              وهيئات الاعتماد، وشركاء اللوجستيات. البنوك: قد نشارك تفاصيل
              المعلومات المالية والبنكية مع البنوك والمؤسسات المالية لمعالجة
              عمليات الدفع، وتأكيد الحجوزات، وتسهيل التحويلات المتعلقة بخدماتنا.
              نتخذ التدابير المناسبة لضمان أن أي أطراف ثالثة نشارك معها بياناتك
              الشخصية تلتزم بمعايير السرية وحماية البيانات الصارمة. نبرم
              اتفاقيات تعاقدية مع هذه الأطراف لضمان أنها تقوم فقط بمعالجة
              بياناتك الشخصية وفقًا لتعليماتنا ولأغراض محددة.
            </Text>
            <Text
              size="xl"
              weight={700}
              style={{ marginBottom: 20, marginTop: 30 }}
            >
              تدابير حماية البيانات:
            </Text>
            <Text>
              في أكاديمية الطبية Infinity، نعطي الأولوية لأمان وحماية بياناتك
              الشخصية لحمايتها من الوصول غير المصرح به، أو الكشف، أو التغيير، أو
              الإتلاف. لقد نفذنا تدابير حماية بيانات قوية لضمان سرية ونزاهة
              وتوفر معلوماتك الشخصية. وفيما يلي بعض من التدابير الرئيسية التي
              نتبعها: التخزين والمعالجة الآمنة: نقوم بمعالجة وتخزين المعلومات
              الشخصية على خوادم وأنظمة كمبيوتر آمنة محمية ببروتوكولات وتدابير
              أمان قياسية صناعية. يتم مراقبة بنية البنية التحتية لدينا بانتظام
              ويتم فحصها لتحديد ومعالجة أي ثغرات أمنية محتملة أو تهديدات.
              التشفير: نستخدم تقنيات التشفير لتشفير البيانات الحساسة أثناء النقل
              والتخزين، بما في ذلك تفاصيل المعلومات المالية والبنكية، لمنع
              الوصول غير المصرح به وضمان سرية البيانات. التحكم في الوصول: يتم
              تقييد الوصول إلى البيانات الشخصية للموظفين المصرح لهم فقط الذين
              لديهم حاجة شرعية للوصول إلى هذه المعلومات لأداء مهامهم الوظيفية.
              يتم منح أذونات الوصول بناءً على مبدأ الامتياز الأقل لتقليل مخاطر
              الوصول غير المصرح به. تقليل البيانات: نقوم بجمع ومعالجة البيانات
              الشخصية فقط التي هي ضرورية للأغراض المذكورة في سياسة الخصوصية
              لدينا. ولا نحتفظ بالبيانات الشخصية لفترة أطول مما هو ضروري ونضمن
              أن أي بيانات لم تعد مطلوبة تختزن بشكل آمن أو تعرض للتعريض لمنع
              الوصول غير المصرح به. تدريب الموظفين: يخضع موظفونا لبرامج تدريب
              منتظمة وبرامج توعية بشأن ممارسات حماية البيانات وأفضل الممارسات في
              مجال الخصوصية لضمان فهمهم لمسؤولياتهم والتزاماتهم بشأن التعامل مع
              البيانات الشخصية. يُطلب منهم الالتزام باتفاقيات السرية الصارمة
              والمعايير الأخلاقية. الفحوصات والتقييمات المنتظمة: نقوم بإجراء
              فحوصات وتقييمات منتظمة لممارسات معالجة بياناتنا وتدابيرنا الأمنية
              وأنظمتنا لتحديد ومعالجة أي ثغرات محتملة أو مخاطر أو ثغرات تنظيمية.
              نسعى باستمرار لتحسين تدابير حماية البيانات لتعزيز أمان معلوماتك
              الشخصية. الامتثال للمتطلبات القانونية: نضمن أن ممارسات معالجة
              بياناتنا تتماشى مع جميع قوانين وتشريعات حماية البيانات السارية،
              بما في ذلك تلك المتعلقة بالمملكة العربية السعودية. نراقب التغييرات
              في التشريعات والمتطلبات التنظيمية لضمان الامتثال المستمر وجعل
              التحديثات اللازمة على سياساتنا وإجراءاتنا. من خلال تنفيذ هذه
              التدابير لحماية البيانات، نهدف إلى تقديم الراحة لك علمًا بأن
              بياناتك الشخصية يتم التعامل معها بشكل آمن ووفقًا لأعلى معايير
              حماية البيانات والخصوصية.
            </Text>
            <Text
              size="xl"
              weight={700}
              style={{ marginBottom: 20, marginTop: 30 }}
            >
              حقوق المستخدم:
            </Text>
            <Text>
              في أكاديمية الطبية Infinity، نلتزم باحترام وتعزيز حقوقك فيما يتعلق
              ببياناتك الشخصية. كموضوع للبيانات، لديك بعض الحقوق في ضوء قوانين
              حماية البيانات السارية، بما في ذلك ولكن لا تقتصر على: الحق في
              المعلومات: لديك الحق في الحصول على المعلومات حول التبرير القانوني
              أو العملي لجمع بياناتك الشخصية وأغراض معالجتها. نحن شفافون حول
              ممارسات معالجة البيانات لدينا ونقدم معلومات واضحة حول كيفية جمع
              واستخدام وحماية بياناتك الشخصية. الحق في الوصول: لديك الحق في
              الوصول إلى بياناتك الشخصية التي نحتفظ بها والتحقق من كيفية
              معالجتها واستخدامها. يمكنك طلب نسخة من بياناتك الشخصية أو طلب
              تصحيح أو تحديث أو حذف البيانات التي تكون غير دقيقة أو غير محدثة.
              الحق في النسخة الاحتياطية: في بعض الحالات، لديك الحق في طلب الحصول
              على نسخة من بياناتك الشخصية بصيغة قابلة للتحميل أو في تنسيق مناسب
              للنقل إلى جهة ثالثة. الحق في الاعتراض: لديك الحق في الاعتراض على
              معالجة بياناتك الشخصية بناءً على أسباب خاصة بك، مثل معالجة
              البيانات لأغراض التسويق المباشر. سنتوقف عن معالجة بياناتك الشخصية
              إذا كان لدينا أسباب مقنعة لعدم استمرار المعالجة، ما لم يكن هناك
              أسباب مقنعة ومبررة للمعالجة أو إذا كانت البيانات مطلوبة لإقامة أو
              ممارسة أو دفاع المطالبات القانونية. الحق في الانسحاب من الرضا: إذا
              كنت قد قدمت موافقتك على معالجة بياناتك الشخصية، يمكنك سحب هذه
              الموافقة في أي وقت. سنحترم قرارك ونتوقف عن معالجة بياناتك الشخصية،
              ما لم يكن هناك أسباب مقنعة للمعالجة. الحق في التقديم للشكوى: إذا
              كنت تعتقد أن معالجة بياناتك الشخصية تتعارض مع قوانين حماية
              البيانات السارية، لديك الحق في تقديم شكوى إلى سلطة الحماية الخاصة
              بالبيانات الشخصية. لمزيد من المعلومات حول حقوقك فيما يتعلق
              ببياناتك الشخصية وكيفية ممارسة هذه الحقوق، يرجى الاتصال بنا
              باستخدام تفاصيل الاتصال المقدمة في القسم التالي.
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginBottom: 20, marginTop: 30 }}
            >
              معلومات الاتصال:
            </Text>
            <Text>
              إذا كان لديك أي أسئلة أو استفسارات أو مخاوف بخصوص سياسة الخصوصية
              لدينا، ممارسات معالجة البيانات، أو بياناتك الشخصية، فلا تتردد في
              الاتصال بنا. يمكنك الوصول إلينا باستخدام تفاصيل الاتصال التالية:
              أكاديمية الطب اللانهائي حي البغدادية - طريق حائل وطريق الأمير
              السعود، جدة، المملكة العربية السعودية أرقام الهاتف: الرئيسية:
              +966570322051 مكتب بديل: +966564572240 البريد الإلكتروني:
              info@infinity.edu.sa فريقنا المخصص متاح لمساعدتك والرد على أي
              مخاوف قد تكون لديك بخصوص بياناتك الشخصية أو ممارسات الخصوصية
              لدينا. نحن نسعى لتقديم ردود شاملة وفورية على جميع الاستفسارات
              وضمان احترام وصون حقوق خصوصيتك.
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginBottom: 20, marginTop: 30 }}
            >
              الامتثال القانوني:
            </Text>
            <Text>
              تلتزم أكاديمية الطب اللانهائي بالامتثال لجميع قوانين وتشريعات
              حماية البيانات السارية، بما في ذلك تلك المعمول بها في المملكة
              العربية السعودية. تلتزم ممارساتنا في معالجة البيانات بمتطلبات
              السلطات المختصة لضمان حماية وسرية معلوماتك الشخصية. كمتحكم في
              البيانات، تضمن أكاديمية الطب اللانهائي أن جميع أنشطة معالجة
              البيانات الشخصية تتم وفقًا للمبادئ والأحكام الموضحة في التشريعات
              السارية لحماية البيانات في المملكة العربية السعودية. نحن ملتزمون
              بصون حقوق الأفراد فيما يتعلق ببياناتهم الشخصية ونسعى جاهدين للحفاظ
              على أعلى معايير حماية البيانات. إذا كانت لديك أي أسئلة أو مخاوف
              بخصوص الامتثال لقوانين حماية البيانات، فلا تتردد في الاتصال بنا.
            </Text>
          </div>
        )}
      </Paper>
    </Container>
  )
}

export default PrivacyPolicyTab
